import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class CustomizationSettingsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllCustomizationSettings(router){
    const url = `/api/customizationSettings`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getCustomizationSettingById(id, router) {
    const url = `/api/customizationSettings/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getCustomizationSettingByFlightSchoolId(id, router) {
    const url = `/api/customizationSettings/school/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createCustomizationSetting(params, router) {
    const url = `/api/customizationSettings`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateCustomizationSetting(id, params, router) {
    const url = `/api/customizationSettings/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  updateCustomizationSettingLogo(id, params) {
    const url = `/api/customizationSettings/logo/${id}`;
    return this.CommonAPIService.newFileCall(url, params);
  }

  deleteCustomizationSetting(id, router) {
    const url = `/api/customizationSettings/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default CustomizationSettingsAPIService;
